var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    hover_cell: true,
    higlight_cell: (_vm.current_row_index >= _vm.row_index) && (_vm.current_item_index >= _vm.item_index),
},on:{"click":function($event){_vm.$parent.set_template(_vm.row_index, _vm.item_index)},"mouseover":function($event){_vm.$parent.set_current(_vm.row_index, _vm.item_index)}}})}
var staticRenderFns = []

export { render, staticRenderFns }